const en = {
  nav: {
    home: 'Home',
    suites: 'Suites',
    history: 'History',
    experiences: 'Experiences',
    gallery: 'Gallery',
    contact: 'Contact',
    reserveNow: 'Book Now'
  },
  home: {
    scrollHint: 'Scroll to book',
    heroTitle: 'Living History',
    heroSubtitle: 'in Ouro Preto',
    checkInOut: 'Check-in / Out',
    checkInPlaceholder: 'e.g.: 05/10 to 05/15',
    guests: 'Guests',
    promoCode: 'Promo Code',
    promoPlaceholder: 'Optional',
    search: 'Search',
    privilegedLocation: 'Prime Location',
    privilegedLocationDesc: 'In the historic heart of Ouro Preto, near the main tourist attractions',
    exceptionalService: 'Exceptional Service',
    exceptionalServiceDesc: 'Dedicated team to make your stay unforgettable',
    luxuryHistory: 'Luxury & History',
    luxuryHistoryDesc: 'Decor that combines colonial charm with modern comfort',
    ourAccommodations: 'Our Accommodations',
    ourAccommodationsDesc: 'Choose from our carefully decorated suites, each offering a unique experience',
    viewAllSuites: 'View All Suites',
    readyToLiveHistory: 'Ready to Live History?',
    readyToLiveHistoryDesc: 'Book now and secure your unforgettable experience in Ouro Preto',
    person: 'Person',
    people: 'People',
    morePeople: '+ People'
  },
  suites: {
    title: 'Our Suites',
    description: 'Each suite has been carefully designed to offer maximum comfort and a unique experience, combining the historic charm of Ouro Preto with modern amenities.',
    size: 'Size',
    capacity: 'Capacity',
    daily: 'Rate',
    viewDetails: 'View Details',
    needHelp: 'Need Help Choosing?',
    needHelpDesc: 'Our team is ready to help you find the perfect suite for your stay.',
    talkOnWhatsApp: 'Chat on WhatsApp',
    standard: {
      name: 'Standard Room',
      subtitle: 'Comfort and Elegance',
      description: 'Our Standard Room offers a welcoming experience with decor that combines the colonial charm of Ouro Preto with modern comfort. Ideal for couples or solo travelers seeking a comfortable stay.',
      amenities: [
        'Comfortable double bed',
        'LED TV with cable channels',
        'High-speed WiFi',
        'Minibar',
        'Private bathroom with hot shower',
        'Safe',
        'Breakfast included'
      ]
    },
    junior: {
      name: 'Junior Suite',
      subtitle: 'Space and Sophistication',
      description: 'The Junior Suite is perfect for those seeking more space and comfort. With ample area and refined decor, it offers a relaxing environment with touches of luxury that reflect the history of Ouro Preto.',
      amenities: [
        'Premium king-size bed',
        'Comfortable seating area',
        'Smart TV 32"',
        'WiFi',
        'Minibar',
        'Safe',
        'Spacious bathroom',
        'Private balcony',
        'Breakfast included'
      ]
    },
    executiva: {
      name: 'Executive Suite',
      subtitle: 'Refinement and Exclusivity',
      description: 'Our Executive Suite is designed for discerning travelers who value premium comfort and differentiated services. With privileged views and elegant decor, it is ideal for extended stays.',
      amenities: [
        'Premium king-size bed',
        '32" TV',
        'Ultra-fast WiFi',
        'Digital safe',
        'Spacious balcony with a view',
        'Breakfast included',
        'Luxury bathroom',
        'Room service',
        'Colonial furniture'
      ]
    },
    master: {
      name: 'Master Suite',
      subtitle: 'The Ultimate in Luxury',
      description: 'The Master Suite is our most luxurious and exclusive accommodation. With sophisticated design, generous space and all imaginable amenities, it provides an unforgettable experience in the heart of Ouro Preto.',
      amenities: [
        'Main bedroom with king-size bed',
        '32" TV with Sky',
        'High-speed WiFi',
        'Safe',
        'Master bathroom',
        'Panoramic balcony',
        'Dedicated room service',
        'Breakfast included',
        'Colonial furniture'
      ]
    },
    backToSuites: 'Back to Suites',
    startingFrom: 'Starting from',
    perNight: 'per night',
    aboutSuite: 'About the Suite',
    amenities: 'Amenities',
    reserveThisSuite: 'Reserve This Suite',
    accommodation: 'Accommodation',
    luxury: 'Luxury'
  },
  history: {
    title: 'Our History',
    quote: '"In the historic heart of Ouro Preto, where every stone tells a story, Pousada do Mondego was born as a tribute to Brazil\'s rich colonial heritage."',
    journeyTitle: 'A Journey Through Time',
    journeyText1: 'Located in the iconic Largo de Coimbra, Pousada do Mondego occupies a building dating back to the 18th century, the golden age of the gold cycle in Minas Gerais. Originally built as a residence for a Portuguese family, the building preserves typical architectural elements of colonial baroque.',
    journeyText2: 'In 2016, after a careful three-year restoration, the building was transformed into a boutique inn, maintaining its historical essence while incorporating all the modern amenities our guests deserve.',
    preservationTitle: 'Preservation with Passion',
    preservationText1: 'Every detail of Pousada do Mondego was designed to honor the history of Ouro Preto. The original stone walls were preserved, solid wood doors and windows were artisanally restored, and colonial decorative elements were integrated into contemporary decor.',
    preservationText2: 'The inn is fully dedicated to the preservation of historical heritage, guided by a deep commitment to conserving our cultural legacy and respecting Brazilian memory.',
    familyTitle: 'The Mondego Family',
    familyText1: 'The name "Mondego" is a tribute to the Mondego River, which runs through the city of Coimbra in Portugal, where the building\'s first owners came from in the 18th century. This Portuguese-Brazilian connection is celebrated in every corner of the inn.',
    familyText2: 'Today, Pousada do Mondego is family managed, who have dedicated themselves to hospitality in Minas Gerais for three generations. With love and dedication, we continue to write new chapters in this centuries-old story.',
    timeline: 'Timeline',
    timeline1747: 'Construction of the original building as a colonial residence',
    timeline1980: 'Beginning of the careful restoration project by the Pereira family',
    timeline1988: 'Opening of Pousada do Mondego', 
    timeline2012: 'Start of the restoration and adaptation process',
    timeline2016: 'Reopening of Pousada do Mondego'
  },
  experiences: {
    title: 'Experiences',
    subtitle: 'Discover the best of Ouro Preto',
    toursActivities: 'Events',
    toursDesc: 'Our concierge team can arrange unique experiences to make your stay unforgettable',
    historicalTours: 'Historical Tours',
    adventureNature: 'Adventure and Nature',
    cultureGastronomy: 'Culture and Gastronomy',
    photography: 'Photography',
    events: 'Events',
    weddings: 'Weddings',
    weddingsDesc: 'Make your dream of celebrating in an unforgettable place come true.',
    corporateEvents: 'Corporate Events',
    corporateEventsDesc: 'Bring your team to a breathtaking landscape.',
    customized: 'Customized',
    onRequest: 'On request',
    annualEvents: 'Annual Events',
    annualEventsDesc: 'Ouro Preto hosts cultural events throughout the year',
    customizeExperience: 'Customize Your Experience',
    customizeDesc: 'Contact our concierge team to create a personalized itinerary.',
    talkToConcierge: 'Talk to Concierge',
    duration: 'Duration',
    price: 'Price',
    annualEventsList: {
      anniversary: { name: 'Ouro Preto Anniversary', month: 'July 8', description: 'Municipal holiday.' },
      gastronomicFestival: { name: 'Gastronomic Festival', month: 'July', description: 'Celebration of Minas Gerais cuisine with special menus at local restaurants.' },
      corpusChristi: { name: 'Corpus Christi', month: 'May/June', description: 'National holiday.' },
      holyWeek: { name: 'Holy Week', month: 'March/April', description: 'Traditional religious celebrations with processions and colorful carpets in the streets.' },
      tiradentes: { name: 'Tiradentes Day', month: 'April 21', description: 'National holiday commemorating the leader of the Minas Gerais Conspiracy.' },
      laborDay: { name: 'Labor Day', month: 'May 1', description: 'National holiday.' },
      independence: { name: "Brazil's Independence Day", month: 'September 7', description: 'National holiday.' },
      aparecida: { name: 'Our Lady of Aparecida', month: 'October 12', description: 'National holiday and republic house festivities in Ouro Preto.' },
      finados: { name: "All Souls' Day", month: 'November 2', description: 'National holiday.' },
      republicProclamation: { name: 'Proclamation of the Republic', month: 'November 15', description: 'National holiday.' },
      blackConsciousness: { name: 'National Day of Zumbi and Black Awareness', month: 'November 20', description: 'National holiday.' }
    }
  },
  gallery: {
    title: 'Gallery',
    description: 'Explore the beauty and comfort of Pousada do Mondego through our image gallery',
    categories: {
      facade: 'Facade and Exterior',
      diner: 'Special Diner',
      standard: 'Standard Room',
      junior: 'Junior Suite',
      executive: 'Executive Suite',
      master: 'Master Suite',
      common: 'Common Areas',
      details: 'Details',
      media: 'Mondego in the Media',
      breakfast: 'Breakfast'
    }
  },
  contact: {
    title: 'Contact',
    subtitle: 'We are here to help you',
    getInTouch: 'Get in Touch',
    getInTouchDesc: 'Our team is ready to serve you and make your experience at Pousada do Mondego unforgettable.',
    address: 'Address',
    phone: 'Phone',
    whatsappContact: 'WhatsApp',
    whatsappAvailable: 'WhatsApp available',
    email: 'Email',
    serviceHours: 'Service Hours',
    mondayToFriday: 'Monday to Friday',
    saturday: 'Saturday',
    sundaysHolidays: 'Sundays and Holidays',
    closed: 'Closed',
    socialMedia: 'Social Media',
    sendMessage: 'Send a Message',
    fullName: 'Full Name',
    yourName: 'Your name',
    yourEmail: 'your@email.com',
    message: 'Message',
    howCanWeHelp: 'How can we help you?',
    sendButton: 'Send Message',
    messageSent: 'Message Sent!',
    willReturnSoon: 'We will return soon.',
    ourLocation: 'Our Location',
    checkIn: 'Check-in: 2pm',
    checkOut: 'Check-out: 12pm',
    breakfastIncluded: 'Breakfast included',
    freeWifi: 'Free WiFi',
    freeParking: 'Free Parking'
  },
  cookies: {
    title: 'Cookies',
    text: 'We use cookies to understand how the site is used and to improve your experience. You can accept or decline.',
    accept: 'Accept',
    refuse: 'Decline',
    settings: 'Cookie preferences'
  },
  footer: {
    description: 'A unique accommodation experience in the historic heart of Ouro Preto.',
    quickLinks: 'Quick Links',
    information: 'Information',
    copyright: 'All rights reserved.'
  },
  whatsapp: {
    hello: 'Hello! 👋 I would like to request a quote for *Pousada do Mondego*:',
    period: '📅 *Period:*',
    guests: '👥 *Number of Guests:*',
    code: '🎟️ *Code:*',
    checkAvailability: 'Could you check availability, please?',
    reserveSuite: 'Hello! 👋 I would like to make a reservation for the *{suite}*. Could you send me more information?',
    helpChoosing: 'Hello! I would like help choosing a suite.',
    experiencesInfo: 'Hello! I would like information about tours and experiences.',
    newMessage: '*New Message from Website*',
    name: '*Name:*',
    phone: '*Phone:*',
    toArrange: 'To be arranged'
  }
};

export default en;
